import { FormGroup } from "@angular/forms";
import { FormlyView } from "../FormlyView";
import { FieldDefinition } from "../../../../sections/medicinalProduct/message/fieldDefinition";

export class DrugIngredientEntity extends FormlyView{
    constructor(
        fieldDefinition: FieldDefinition
    ) {
        super(new FormGroup({}), 
            [...fieldDefinition.drugIngredientItemFields], {});
    }
}